import React from "react";
import DashboardCompletedRecord from "./completed-record";
import DashboardPendingRecord from "./pending-record";
import DashboardProcessingRecord from "./processing-record";

class DashboardTimelineItem extends React.Component {
    render() {
        const { item } = this.props;
         return (
            <div>
                <div className='timeline-boxes-w'>
                     { (item.ProcessStatus === 102) &&
                        <DashboardCompletedRecord report={item}/>
                     }
                    {
                        (item.ProcessStatus === 101)
                        && <DashboardProcessingRecord report={item}/>
                    }
                    {
                        (item.ProcessStatus === 100) &&
                        <DashboardPendingRecord report={item}/>
                    }
                </div>
            </div>
        )
    }
}
export default DashboardTimelineItem;


// WEBPACK FOOTER //
// ./src/views/dashboard/timeline-item.js